import { render, staticRenderFns } from "./SlideManageView.vue?vue&type=template&id=5ed20aae&scoped=true"
import script from "./SlideManageView.vue?vue&type=script&lang=js"
export * from "./SlideManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed20aae",
  null
  
)

export default component.exports